import { Add, Checklist, Delete } from "@mui/icons-material";
import {
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { useModal } from "@refinedev/core";
import { AddProductDialog } from "./AddProductDialog";
import React, { useState } from "react";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { DeleteProductDialog } from "./DeleteProductDialog";

export const ActionsButton = () => {
  const { translate } = useTranslation(
    "pages.inventoryManagement.inventory.actions",
  );

  const { show: showAdd, close: closeAdd, visible: addVisible } = useModal();
  const {
    show: showDelete,
    close: closeDelete,
    visible: deleteVisible,
  } = useModal();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClick}
        startIcon={<Checklist />}
      >
        {translate("button")}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          onClick={() => {
            showAdd();
            handleClose();
          }}
        >
          <ListItemIcon>
            <Add fontSize="small" />
          </ListItemIcon>
          <ListItemText>{translate("addNewProduct.title")}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            showDelete();
            handleClose();
          }}
        >
          <ListItemIcon>
            <Delete fontSize="small" />
          </ListItemIcon>
          <ListItemText>{translate("deleteProducts.title")}</ListItemText>
        </MenuItem>
      </Menu>

      <AddProductDialog open={addVisible} onClose={closeAdd} />
      <DeleteProductDialog open={deleteVisible} onClose={closeDelete} />
    </>
  );
};
